import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
const ComponentWrapper = styled.div `
  display: ${({ $content, $cover }) => ($content || $cover ? 'flex' : 'inline-flex')};
  justify-content: center;
  align-items: center;
  height: ${({ $content, $height }) => ($content ? '100%' : $height ? `${$height}px` : undefined)};
  width: ${({ $fullWidth }) => $fullWidth && '100%'};
  flex: ${({ $content }) => $content && 'auto'};
  ${({ $background, theme, $content, $cover }) => !$content &&
    css `
      position: relative;
      &:before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${$background ?? theme.colors.grey00_1};
        opacity: ${$cover ? 0.7 : 1};
      }
    `}
  ${({ $cover }) => $cover &&
    css `
      position: absolute;
      z-index: 2;
      inset: 0;
    `}
`;
const LoaderComponent = styled.i `
  @keyframes around {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  position: relative;
  height: ${({ size, $content }) => size ?? ($content ? '35px' : '15px')};
  width: ${({ size, $content }) => size ?? ($content ? '35px' : '15px')};
  display: inline-block;
  animation: around 5.4s infinite;

  &:after,
  &:before {
    content: '';
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-width: 1px;
    border-color: ${({ $fill, theme }) => $fill ? `${$fill} ${$fill} transparent transparent` : `${theme.colors.black_1} ${theme.colors.black_1} transparent transparent`};
    border-style: solid;
    border-radius: ${({ size, $content }) => size ?? ($content ? '35px' : '15px')};
    box-sizing: border-box;
    top: 0;
    left: 0;
    animation: around 0.7s ease-in-out infinite;
  }

  &:after {
    animation: around 0.7s ease-in-out 0.1s infinite;
    background: transparent;
  }
`;
const _Loader = ({ className, background, content, height, fullWidth, cover, fill, size, dataTestId }) => (_jsx(ComponentWrapper, { className: className, "$background": background, "$content": content, "$height": height, "$fullWidth": fullWidth, "$cover": cover, "data-testid": dataTestId, children: _jsx(LoaderComponent, { "$fill": fill, size: size, "$content": content }) }));
export const Loader = React.memo(_Loader);
